import { Repeat } from '../Repeat';
import css from './styles.module.css';

export const Table = ({ ratio, cupSize }) => {
  const calcWater = index => {
    const water = (index + 1) * cupSize;

    if (isNaN(water)) {
      return 0;
    }

    return water;
  };

  const calcCoffee = index => {
    const coffee = calcWater(index) / ratio;

    if (coffee === Infinity) {
      return 0;
    }

    if (isNaN(coffee)) {
      return 0;
    }

    return coffee.toFixed(1);
  };

  return (
    <section className={css.main}>
      <table>
        <thead>
          <tr>
            <th>Kaffe</th>
            <th>Vann</th>
            <th>Kopper</th>
          </tr>
        </thead>
        <tbody>
          <Repeat numberOfTimes={10}>
            {index => (
              <tr key={index}>
                <td className={css.coffee}>{calcCoffee(index)}g</td>
                <td className={css.water}>{calcWater(index)}ml</td>
                <td className={css.cups}>{index + 1}</td>
              </tr>
            )}
          </Repeat>
        </tbody>
      </table>
    </section>
  );
};
